import { useMutation } from '@tanstack/react-query';

import { suggestProcrastinationTask } from '../api/procrastinationApi';

interface SuggestTaskParams {
  energy: number;
  excludeTaskId?: number;
}

// §8.1: результат живёт в локальном UI state экрана, не в кеше React Query.
export function useSuggestTask() {
  return useMutation({
    mutationFn: ({ energy, excludeTaskId }: SuggestTaskParams) =>
      suggestProcrastinationTask(energy, excludeTaskId),
  });
}
